import React, { useEffect, useState, createContext, useContext } from 'react';
import { t } from '@lingui/macro';
import { Button, Typography } from '@pocketlaw/tetris';
import { useCompanyFeatures } from 'app/domains/companies';
import { ReviewChat, usePlai } from 'app/domains/review';
import { DocumentDrawerHeader } from 'shared/domains/documents';
import { FeatureNotAvailable } from './FeatureNotAvailable';
import { ReviewInProgress } from './ReviewInProgress';
import { Root } from './Root';
import { getChip } from './utils';
import { DrawerContainer, Scroller } from './styled';
const PlaiDrawerContext = createContext(null);
export const usePlaiDrawer = () => {
    const context = useContext(PlaiDrawerContext);
    if (!context) {
        throw new Error('usePlaiDrawer hook must be used as a child to <ReviewDrawer>');
    }
    return context;
};
export function ReviewDrawer({ onClose }) {
    const { isFeatureAvailable } = useCompanyFeatures();
    const canUseReviewAgent = isFeatureAvailable('review-agent:basic');
    const [activeFeedbackId, setActiveFeedbackId] = useState(null);
    const { review, requestingReview, reviewing, requestReview } = usePlai();
    const noReviewYet = review === null && !reviewing && !requestingReview;
    useEffect(() => {
        if (noReviewYet && canUseReviewAgent) {
            // TODO: handle error when request fails
            // requestReview();
        }
    }, [noReviewYet, requestReview, canUseReviewAgent]);
    if (!canUseReviewAgent) {
        return <FeatureNotAvailable />;
    }
    const title = t({
        comment: 'Plai review drawer - title',
        message: 'Review',
    });
    if (noReviewYet || reviewing || requestingReview) {
        return (<DrawerContainer>
        <DocumentDrawerHeader type="root" title={title} onClose={onClose}/>
        <Typography>DEV note: automatic review has been disabled</Typography>
        <Button onClick={() => requestReview()} disabled={reviewing || requestingReview}>
          {reviewing || requestingReview ? 'Review in progress' : 'Start review'}
        </Button>

        <ReviewInProgress />
      </DrawerContainer>);
    }
    const activeFeedback = review === null || review === void 0 ? void 0 : review.feedbacks.find(feedback => feedback.feedback.id === activeFeedbackId);
    if (activeFeedback) {
        return (<DrawerContainer>
        <DocumentDrawerHeader type="nested" title={activeFeedback.feedback.name} onClose={onClose} actions={getChip(activeFeedback.feedback.criticality)} onGoBack={() => setActiveFeedbackId(null)}/>
        <ReviewChat feedbackId={activeFeedback.feedback.id}/>
      </DrawerContainer>);
    }
    const value = {
        onSelectFeedback: id => setActiveFeedbackId(id),
    };
    return (<PlaiDrawerContext.Provider value={value}>
      <DrawerContainer>
        <DocumentDrawerHeader type="root" title={title} onClose={onClose}/>
        <Scroller>
          <Root />
        </Scroller>
      </DrawerContainer>
    </PlaiDrawerContext.Provider>);
}
